import { zodResolver } from '@hookform/resolvers/zod';
import { Login } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';
import alertaiLogo from 'assets/images/logoProdutos/alertai_icon_light.svg';
import ButtonComponent from 'components/ButtonComponent';
import TextFieldComponent from 'components/TextFieldComponent';
import { AppContext } from 'context/AppContextProvider';
import { useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { useQRCodeLoginAsync } from 'services/AuthService/hooks/useMutations';
import { LoginFormSchema } from 'services/AuthService/schemas';
import z from 'zod';

type LoginFormInput = z.infer<typeof LoginFormSchema>;

export const QRCodeLoginPage = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormInput>({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: { email: '', password: '' },
  });

  const { showSnackbar } = useContext(AppContext);

  const theme = useTheme();

  const [searchParams] = useSearchParams();

  const token: string | null = searchParams.get('token');

  const [isLoginSuccessfull, setIsLoginSuccessful] = useState<boolean>(false);

  const { mutateAsync: mutateQRCodeLogin, isLoading: isLoadingQRCodeLogin } =
    useQRCodeLoginAsync();

  const handleSubmition = async (data: LoginFormInput) => {
    if (token) {
      await mutateQRCodeLogin({ token, data }).then(() =>
        setIsLoginSuccessful(true),
      );
    } else {
      showSnackbar('token do dispositivo inválido.', 'error');
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {isLoginSuccessfull ? (
        <Box>Login realizado com sucesso! Pode fechar a guia.</Box>
      ) : (
        <Box
          sx={{
            width: { xs: '100%', sm: '80%', md: '35%' },
            m: 1,
            p: 2,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderColor: theme.palette.secondary.main,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              mb: 3,
            }}
          >
            <img
              src={alertaiLogo}
              alt="alertai-logo"
              width={200}
              height={200}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: { xs: '100%', sm: '80%' },
            }}
          >
            <Controller
              control={control}
              name="email"
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  value={value}
                  onChangeText={onChange}
                  error={!!error}
                  errorMessage={error?.message}
                  label="Email"
                  type="email"
                />
              )}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: { xs: '100%', sm: '80%' },
            }}
          >
            <Controller
              control={control}
              name="password"
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  value={value}
                  onChangeText={onChange}
                  error={!!error}
                  errorMessage={error?.message}
                  label="Senha"
                  type="password"
                />
              )}
            />
          </Box>
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <ButtonComponent
              size="large"
              type="submit"
              color="primary"
              variant="contained"
              endIcon={<Login />}
              loading={isLoadingQRCodeLogin}
              loadingPosition="end"
              onClick={handleSubmit(handleSubmition)}
            >
              Entrar
            </ButtonComponent>
          </Box>
        </Box>
      )}
    </Box>
  );
};
